import { ApplicationRootPageComponent, ErrorUnauthorizedPageComponent, RedirectOrderPageComponent } from './pages';
import { VariationRootPageComponent } from 'root/pages/variation-root/variation-root-page.component';
import { Routes } from '@angular/router';
import { Error404Component } from 'root/components';
import { PermissionPolicy } from 'root/services';
import { StartupCanActivateChildFn, StartupCanActivateFn } from './guards';
import { MibpNewUXRedirectCanActivateFn } from './guards/new-ux-redirect/new-ux-redirect.guard';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FilterPresetResolver } from './services/filter/filter-preset.resolver';

import { permissionPolicyKey } from 'root/services/permission';


@Component({
  selector: 'mibp-bug-297854-component',
  template: 'https://dev.azure.com/sandvik/MIBP/_workitems/edit/297854',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: []
})
export class Bug297854DummyComponent {}


export const appRoutes: Routes = [
  {
    path: '',
    canActivate: [StartupCanActivateFn],
    canActivateChild: [StartupCanActivateChildFn],
    data: {
      isRoot: true,
      mibpGuard: { allowAnonymous: true, postponeSignalrConnection: true }
    },
    children: [
      {
        path: '',
        component: VariationRootPageComponent,
        data: {
          mibpGuard: {
            skipGuardForRoute: true,
            allowAnonymous: true
          }
        },
      },      
      {
        path: ':lang',
        component: ApplicationRootPageComponent,
        data: {
          setLang: true,
          mibpGuard: {
            postponeSignalrConnection: true,
            allowAnonymous: true
          }
        },
        resolve: {
          voidReturnPlaceholder: FilterPresetResolver
        },        
        children:  [
          {
            path: 'unauthorized',
            component: ErrorUnauthorizedPageComponent,
            data: {
              mibpGuard: { allowAnonymous: true, postponeSignalrConnection: false }
            }
          },
          {
            path: 'redirect/order',
            component: RedirectOrderPageComponent,
            data: {
              mibpGuard: {
                allowAnonymous: false
              }
            }
          },
          {
            path: 'user',
            children: [
              {
                path: '',
                loadChildren: () => import('./modules/user/routes').then(m => m.userRoutes),
              }
            ]
          },
          {
            path: '',
            loadChildren: () => import('./modules/home/routes').then(m => m.homeRoutes),
            data: {
              mibpGuard: {
                allowAnonymous: false
              }
            }
          },
          {
            path: 'home',
            redirectTo: ''
          },

          // START:  Can not remove this or we get weird error in prod build
          // https://dev.azure.com/sandvik/MIBP/_workitems/edit/297854
          {
            path: 'electronic-manuals',
            canActivate: [MibpNewUXRedirectCanActivateFn],
            component: Bug297854DummyComponent,
            // When the data section is not here, then the error occurs
            data: {
              mibpGuard: {
                permissionPolicy: permissionPolicyKey('canSeeElectronicManuals')
              }
            },
          },
          // END:  Can not remove this or we get weird error in prod build


          {
            path: 'settings',
            children: [
              {
                path: '',
                loadChildren: () => import('./modules/settings/settings.routes').then(m => m.routes),
                data: {
                  mibpGuard: {
                    allowAnonymous: false
                  }
                }
              }
            ]
          },
          {
            path: 'operations',
            children: [
              {
                path: '',
                loadChildren: () => import('./modules/operations/operations.routes').then(m => m.routes),
                data: {
                  mibpGuard: {
                    permissionPolicy: permissionPolicyKey('isSupportTeamMember')
                  }
                }
              }
            ]
          },
          {
            path: 'warranty-portal',
            children: [
              {
                path: '',
                loadChildren: () => import('./modules/warranty-portal/warranty-portal.routes').then(m => m.routes),
                data: {
                  mibpGuard: {
                    allowAnonymous: true
                  },
                  navItemId: 'warranty-portal'
                }
              }
            ]
          },          
          {
            path: '**',
            component: Error404Component,
            data: {
              error: { code: 404, path: ':lang/**' },
              mibpGuard: {
                skipGuardForRoute: true,
                allowAnonymous: true
              }
            }
          }
        ]
      }
    ]
  }
];
